export default {"src":"/newStatic/_next/static/media/pattern-1.17b859b0.svg","height":180,"width":1280};